import React from 'react';
import './datametrics.scss';

const DataMetrics = (props) => {
  return (
    <div className={`metric-item ${props.classes}`}>
      {props.header && (
        <div className="metric-header">
          { props.header }
        </div>
      )}
      {props.children}
    </div>
  )
}

export default DataMetrics;